import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import React from 'react';

import {
  LANDSCAPE_TOOLBAR_MENU_WIDTH,
  LANDSCAPE_TOOLBAR_WIDTH,
} from 'src/modules/designStudio/components/Toolbar/toolBarConstants';
import type { Menu } from 'src/modules/designStudio/constants';
import { SlideRightCard } from 'src/shared/components/SlideRightCard';

type SlideRightMenuProps = {
  closeMenu: () => void;
  menu: Menu | null;
  containerRef?: React.RefObject<HTMLElement>;
} & BoxProps;

const SlideRightMenu = ({
  children,
  closeMenu,
  containerRef,
  menu,
  backgroundColor,
  ...props
}: SlideRightMenuProps) => {
  const computedMenuWidth =
    LANDSCAPE_TOOLBAR_WIDTH + LANDSCAPE_TOOLBAR_MENU_WIDTH;
  return (
    <SlideRightCard
      closeOnOverlayClick={false}
      contentProps={{
        backgroundColor,
        left: 'env(safe-area-inset-left, 0px)',
        maxWidth: `${computedMenuWidth}px`,
        padding: 0,
        paddingLeft: `${LANDSCAPE_TOOLBAR_WIDTH}px`,
      }}
      id="slide-right-card"
      isClosable={false}
      isOpen={!!menu}
      isOverlay={false}
      onClose={closeMenu}
      placement="left"
      portalProps={{ containerRef }}
      size="large"
    >
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        overflowY="auto"
        padding={600}
        position="relative"
        {...props}
      >
        {children}
      </Box>
    </SlideRightCard>
  );
};

export { SlideRightMenu, SlideRightMenuProps };
